import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tokens, setTokens] = useState(null);

  useEffect(() => {
    // Check if user is already logged in (tokens in localStorage)
    const storedTokens = localStorage.getItem('tokens');
    if (storedTokens) {
      try {
        const parsedTokens = JSON.parse(storedTokens);
        setTokens(parsedTokens);
        // TODO: Fetch user data from API using access token
        setUser({ email: 'demo@atlasintelgroup.com' }); // Placeholder
      } catch (error) {
        console.error('Error parsing stored tokens:', error);
        localStorage.removeItem('tokens');
      }
    }
    setLoading(false);
  }, []);

  const login = (cognitoTokens) => {
    setTokens(cognitoTokens);
    localStorage.setItem('tokens', JSON.stringify(cognitoTokens));
    // TODO: Fetch user data from API
    setUser({ email: 'demo@atlasintelgroup.com' }); // Placeholder
  };

  const logout = () => {
    try {
      // Clear local state first
      setUser(null);
      setTokens(null);
      localStorage.removeItem('tokens');

      // Build Cognito logout URL
      const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
      const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
      const logoutUrl = import.meta.env.VITE_LOGOUT_URI || import.meta.env.VITE_APP_URL || window.location.origin;

      if (!cognitoDomain || !clientId) {
        console.error('Missing Cognito configuration for logout');
        window.location.href = '/';
        return;
      }

      const logoutEndpoint = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUrl)}`;

      // Redirect to Cognito logout
      window.location.replace(logoutEndpoint);
    } catch (error) {
      console.error('Logout error:', error);
      // Fallback: redirect to home
      window.location.href = '/';
    }
  };

  const value = {
    user,
    tokens,
    loading,
    login,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
